module.exports = __webpack_public_path__ + "static/img/25.f52144b4.png";